import type { RuleNames } from "./feature-names";

/** Dutch names of the company rules and rule categories. Same keys as rules.fr.ts. */
export const rulesNl: RuleNames = {
  rules: {
    REFUND_OWNER_APPROVAL_ABOVE_RULE: "Akkoord van de eigenaar boven",
    ID_IMAGE_RETENTION_RULE: "Bewaartermijn van ID-afbeeldingen",
    FIRST_REPLY_TARGET_RULE: "Termijn voor het eerste antwoord",
    INTERIM_SUSPENSION_REVIEW_RULE: "Herziening van een voorlopige schorsing",
    UNANSWERED_JOB_EXPIRY_RULE: "Verloop van een onbeantwoorde aanvraag",
    SUBSCRIPTION_GRACE_PERIOD_RULE: "Respijtperiode van een abonnement",
    STAFF_SESSION_INACTIVITY_RULE: "Afmelden na inactiviteit",
  },
  categories: {
    payments: "Betalingen",
    support: "Dossiers",
    safety: "Vertrouwen & veiligheid",
    onboarding: "Verificatie",
    jobs: "Aanvragen",
    access: "Toegang",
  },
};
